// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.css
// module id = /wAz
// module chunks = 41